import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { CustomButton, CustomTable } from '../../shared/uiComponents';
import { useCheckPermission, useScreenWidth } from '../../shared/Helpers/hooks';
import { AdminTypes } from '../../components/Menu';
import SearchBar from '../../components/SearchBar';
import { Container, Header } from '../../components/StyledComponents';
import { Headers, TableBody } from './tableInfo';
import MobileView from './mobileView';
import { PERMISSIONS } from '../../App/constants';

import { DispatchProperties, useSelector } from '../../redux/store';
import { getBCBAs } from '../../redux/State/userSlice';
import { PageHeader } from '../../components/PageHeader';
import { PlusIcon } from '../../shared/Assets/svg';
import { Certificate } from '../../shared/Assets/menuIcons';

const BCBA = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch<DispatchProperties>();
	const { permissionGranted } = useCheckPermission(PERMISSIONS.USER.CREATE);
	const [params] = useSearchParams();

	const page = params.get('page') || '1';
	const pageSize = params.get('pageSize') || '8';
	const orderBy = params.get('orderBy') || '';
	const direction = params.get('direction') || '';
	const searchString = params.get('search') || '';

	const usersData = useSelector((state) => state.user.bcbas);
	const loading = useSelector((state) => state.user.loading);

	useEffect(() => {
		dispatch(getBCBAs({ page, pageSize, orderBy, direction, searchString }));
	}, [page, pageSize, orderBy, direction, searchString, dispatch]);

	const addBcbaHandler = () => {
		window.localStorage.setItem('formType', AdminTypes[1]);
		navigate('/bcba/new');
	};

	const screenWidth = useScreenWidth();

	const headerContent = (
		<>
			<SearchBar style={{ marginTop: 0 }} />
			{permissionGranted && <CustomButton title="Add BCBA" onClick={addBcbaHandler} startIcon={<PlusIcon />} />}
		</>
	);

	return (
		<>
			{screenWidth >= 768 ? (
				<Container>
					<Header>
						<PageHeader icon={<Certificate />} title="BCBA" isInContainer headerContent={headerContent} />
					</Header>
					<CustomTable headers={Headers} data={usersData} TableBody={TableBody} loading={loading} />
				</Container>
			) : (
				<MobileView {...usersData} />
			)}
		</>
	);
};

export default BCBA;
